import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { OrderServicoRequest, Response } from './Types';

class OrdemServicoController {
  public static async Listar(request: OrderServicoRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/ordemservico/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(os_id: number): Promise<Response> {
    try {
      const { data, status } = await Api.get(
        `api/ordemservico/ListarUnico/${os_id}`
      );
      const retorno: Response = {
        StatusCode: status,
        Data: data,
      };

      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: OrderServicoRequest): Promise<Response> {
    try {    
      const response = await Api.post(`api/ordemservico/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: OrderServicoRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/ordemServico/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: OrderServicoRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/ordemservico/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        Message: error.response?.data?.message
      };
      return retorno;
    }
  }

  public static async AlterarStatus(request: OrderServicoRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/ordemservico/AlterarStatus`, request);
      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const backendData = error?.response?.data; // aqui vem ErrosExcessoes do C#

      return {
        StatusCode: error?.response?.status,
        Data: backendData || { Erro: 'Erro desconhecido', ErroDetalhado: '' },
      };
      // const retorno: Response = {
      //   StatusCode: error?.response?.status,
      //   Data: ErrorDictionary(error?.response?.status),
      // };
      // return retorno
    }
  }

  public static async ListarOrdemServicoMaquina(MaquinaId: number): Promise<Response> {
    try {
      const response = await Api.get(
        `api/ordemservico/ListarOrdemServicoMaquina/${MaquinaId}`
      );
      console.log('ACABOU DE SAIR DA PROCEDURE');
      console.log(response?.data);
      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object,
      };
      return retorno;

    } catch (error: any) {

      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };

      return retorno;
    }
  }
}

export default OrdemServicoController;
